export default __webpack_public_path__ + "static/media/speed.fdcdf85f.jpg";